import { OfferRegion } from "./trial-offer.config";

export interface LegalLinks {
  privacyUrl: string;
  termsUrl: string;
}

/**
 * FLIP-652. The Privacy Policy and Terms of Use for each region, in one place. Both regions point at
 * the same live documents (FLIP-653); give a region its own entry here if a regional document is published.
 */
const CURRENT_LEGAL_LINKS: LegalLinks = {
  privacyUrl: "https://legal.get-flipped.app/privacy/",
  termsUrl: "https://legal.get-flipped.app/terms/",
};

export const LEGAL_LINKS: Record<OfferRegion, LegalLinks> = {
  au: CURRENT_LEGAL_LINKS,
  us: CURRENT_LEGAL_LINKS,
};

/** The links for a region; anything unrecognised gets the Australian ones, as with prices. */
export function legalLinks(region: OfferRegion): LegalLinks {
  return LEGAL_LINKS[region] ?? LEGAL_LINKS.au;
}
